<template>
  <div>
    <footer class="footer d-none d-md-block" v-if="$route.name !== 'Final Ticket'">
      <div class="rainbow-line rainbow-line-sm mb-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-3">
            <!-- <img
              src="@/assets/img/miraj-logo-color.svg"
              class="img-fluid footer-logo-img"
              alt
            /> -->
            <img src="@/assets/logos/logo-2.png" class="img-fluid footer-logo-img" alt />
            <!-- <img
              src="@/assets/logos/Miraj-Cinemas-footer-Logo.svg"
              class="img-fluid"
              alt
            /> -->
          </div>

          <div class="col-md-3">
            <ul class="footer-links-list">
              <li>
                <router-link to @click.native="() => $router.push({ name: 'About Us' })"
                  :class="$route.path == '/about-us' ? 'active' : null">About Us</router-link>
              </li>
              <!-- <li>
                <router-link
                  to
                  @click.native="
                    () => $router.push({ name: 'Offers And Promotions' })
                  "
                  :class="
                    $route.path == '/offers-and-promotions' ? 'active' : null
                  "
                  >Offers and promotions</router-link
                >
              </li> -->
              <li>
                <router-link to @click.native="
                  () => $router.push({ name: 'Advertise With Us' })
                " :class="$route.path == '/advertise-with-us' ? 'active' : null">Advertise with us</router-link>
              </li>
              <li>
                <router-link to @click.native="() => $router.push({ name: 'Careers' })"
                  :class="$route.path == '/careers' ? 'active' : null">Careers</router-link>
              </li>
              <!-- <li>
              <router-link to="privacy-policy">Help</router-link>
              </li>-->
              <li>
                <router-link to @click.native="() => $router.push({ name: 'Contact Us' })"
                  :class="$route.path == '/contact-us' ? 'active' : null">Contact Us</router-link>
              </li>
              <li>
                <router-link to @click.native="() => $router.push({ name: 'Investors' })"
                  :class="$route.path == '/investors' ? 'active' : null">Investors</router-link>
              </li>
              <li>
                <router-link to @click.native="
                  () => $router.push({ name: 'Terms and Conditions' })
                " :class="$route.path == '/terms-and-conditions' ? 'active' : null
                  ">Terms and conditions</router-link>
              </li>
              <li>
                <router-link to @click.native="() => $router.push({ name: 'Privacy Policy' })"
                  :class="$route.path == '/privacy-policy' ? 'active' : null">Privacy Policy</router-link>
              </li>
            </ul>
          </div>

          <div class="col-md-3">
            <ul class="footer-links-list">

              <!-- <li>
                <router-link
                  to
                  @click.native="
                    () => $router.push({ name: 'Refunds And Cancellation' })
                  "
                  :class="
                    $route.path == '/refunds-and-cancellation' ? 'active' : null
                  "
                  >Refunds and Cancellations</router-link
                >
              </li> -->
              <!-- <li>
                <router-link
                  to="refunds-and-cancellation"
                  :class="$route.path == '/refunds-and-cancellation' ? 'active' : null"
                >Refunds &amp; Cancellation</router-link>
              </li> -->
              <!-- <li>
              <router-link
                to="terms-and-conditions"
                :class="$route.path == '/asd' ? 'active' : null"
              >User Policy</router-link>
              </li>-->
              <!-- <li>
              <router-link
                to="terms-and-conditions"
                :class="$route.path == '/ asda' ? 'active' : null"
              >Join Us</router-link>
              </li>-->
              <li>
                <router-link class="no-hover-effect font-weight-bold" to>Customer Care</router-link>
              </li>
              <li>
                <template v-if="customer_care_email">
                  <div v-html="customer_care_email"></div>
                </template>
                <!-- <template v-else>
                  <p class="mb-0 small"><a target="_blank" class="font-weight-light"
                      href="mailto:contactus@mirajcinemas.com">contactus@mirajcinemas.com</a></p>
                </template> -->
              </li>
              <li class="mt-3">
                <router-link class="no-hover-effect font-weight-bold" to></router-link>
              </li>
              <li>
                <template v-if="address">
                  <div v-html="address"></div>
                </template>
                <!-- <template v-else>
                  <p class="mb-0 small">
                    <a class="no-hover-effect font-weight-light">
                      Miraj Entertainment Limited <br />
                      CIN: U92100RJ2008PLC026391<br />
                      State Name : Maharashtra , Code : 27<br />
                      Place of Supply : Maharashtra
                    </a>
                  </p>
                  <p class="mb-0 small">
                    <a class="no-hover-effect font-weight-light">
                      Anoli Holdings Limited <br /> 
                      CIN : U65990GJ1981PTC004587
                    </a>
                  </p>
                </template> -->
              </li>
            </ul>
          </div>

          <div class="col-md-3">
            <!-- d-flex flex-column justify-content-between -->
            <!-- <div class="newsletter">
            <button class="btn-transparent">
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.5442 0.456514C21.3562 0.269514 21.0762 0.214514 20.8302 0.315514L0.666165 8.73451C0.420165 8.83751 0.263165 9.07551 0.264165 9.34151C0.266165 9.60751 0.426165 9.84351 0.673165 9.94351L8.78216 13.2185L12.0572 21.3265C12.1572 21.5735 12.3932 21.7335 12.6632 21.7355C12.9282 21.7355 13.1642 21.5775 13.2662 21.3335L21.6842 1.17051C21.7872 0.924515 21.7322 0.644514 21.5442 0.456514ZM14.2912 8.63351C14.4142 8.51051 14.4822 8.34551 14.4822 8.17151C14.4822 7.99651 14.4142 7.83251 14.2912 7.70951C14.0362 7.45451 13.6222 7.45451 13.3672 7.70951L9.12817 11.9485L2.63816 9.32751L19.8662 2.13451L12.6732 19.3625L10.0522 12.8725L14.2912 8.63351Z"
                  fill="#ED1C24"
                />
              </svg>
            </button>
            <input
              type="text"
              class="form-control"
              placeholder="Subscribe to our newsletter and stay updated"
            />
            </div>-->
            <div>
              <strong class="pb-1 d-block">Follow Us</strong>
              <ul class="list-inline mb-0 d-flex">
                <li class="list-inline-item">
                  <a href="https://www.facebook.com/MirajCinemas/" target="_blank" title="Facebook">
                    <svg width="29" height="29" viewBox="0 0 29 29" fill=" #e7beb3" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M28.9999 14.4739C29.026 22.4658 22.5323 28.9739 14.5521 28.9999C6.51977 29.026 0 22.5179 0 14.5C0 6.48203 6.49369 0 14.4739 0C22.4802 0 28.9738 6.456 28.9999 14.4739ZM12.1268 14.4219C12.1268 17.4416 12.1268 20.3572 12.1268 23.2989C13.3786 23.2989 14.5782 23.2989 15.83 23.2989C15.83 20.3312 15.83 17.4156 15.83 14.4219C16.6906 14.4219 17.473 14.4219 18.3075 14.4219C18.4118 13.3545 18.5161 12.3653 18.6205 11.298C17.6555 11.298 16.7688 11.298 15.8039 11.298C15.8039 10.6472 15.8039 10.0745 15.8039 9.50177C15.83 8.82493 16.0647 8.59064 16.7688 8.59064C17.3426 8.59064 17.9163 8.59064 18.5422 8.59064C18.5422 7.54935 18.5422 6.58616 18.5422 5.54487C17.5512 5.54487 16.6124 5.4928 15.6474 5.54487C13.3003 5.70106 12.1268 6.97664 12.1007 9.31954C12.1007 9.97035 12.1007 10.6212 12.1007 11.324C11.4748 11.324 10.9271 11.324 10.3534 11.324C10.3534 12.3913 10.3534 13.4066 10.3534 14.4479C10.9532 14.4219 11.4748 14.4219 12.1268 14.4219Z"
                        fill="#fff" />
                    </svg>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a href="https://twitter.com/MirajCinemas" target="_blank" title="Twitter">
                    <svg width="29" height="29" viewBox="0 0 29 29" fill=" #e7beb3" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M14.474 7.78957e-05C22.4256 -0.0259777 28.948 6.48791 28.9999 14.4349C29.0259 22.3818 22.5035 28.9739 14.5779 28.9999C6.54837 29.026 0 22.486 0 14.487C0 6.54002 6.4964 0.0261335 14.474 7.78957e-05ZM7.97758 16.8841C8.44532 18.3953 9.66664 18.9425 11.1478 19.4375C10.5242 19.7763 10.1344 20.0629 9.69262 20.2192C8.67918 20.5579 7.63976 20.7924 6.54837 21.1051C6.83421 21.2614 7.12005 21.4699 7.43188 21.6001C13.3306 24.2057 20.2168 20.6621 21.5421 14.3306C21.8539 12.8194 21.646 11.1258 23.1532 10.0054C22.7634 10.0836 22.3736 10.1357 21.8799 10.2139C22.2697 9.64064 22.6075 9.19769 22.9193 8.72869C22.8673 8.62447 22.8413 8.49419 22.7894 8.38997C21.646 9.35403 20.6845 8.91108 19.5671 8.41603C18.7616 8.05125 17.5922 8.10336 16.7347 8.38997C14.9417 8.98925 14.474 10.6047 14.474 12.4546C11.4337 12.3765 9.12094 10.8913 7.06808 8.80686C6.28851 10.6047 6.6783 12.0638 7.97758 13.4708C7.43188 13.4447 7.06808 13.4187 6.65231 13.3666C6.73027 15.0862 7.76969 15.9982 9.1989 16.7538C8.67919 16.7799 8.36736 16.832 7.97758 16.8841Z"
                        fill="#fff" />
                    </svg>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a href="https://instagram.com/mirajcinemas?igshid=MTIyMzRjYmRlZg==" target="_blank"
                    title="Instagram">
                    <svg width="29" height="29" viewBox="0 0 29 29" fill=" #e7beb3" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M14.5391 7.89082e-05C22.5901 0.0261579 29.0518 6.49375 28.9997 14.4739C28.9476 22.5584 22.4598 29.026 14.4088 28.9999C6.46198 28.9738 -0.0517998 22.3759 0.000310502 14.4218C0.0263657 6.41551 6.54015 -0.0260001 14.5391 7.89082e-05ZM6.67042 14.5522C6.67042 15.6736 6.64437 16.821 6.67042 17.9424C6.72253 20.6286 8.3119 22.3498 11.0216 22.4541C13.2884 22.5323 15.5292 22.5323 17.796 22.4541C20.5057 22.3498 22.0951 20.6546 22.1472 17.9424C22.1732 15.7257 22.1732 13.509 22.1472 11.2923C22.0951 8.60615 20.4015 6.88493 17.7439 6.83278C15.5292 6.8067 13.3145 6.78062 11.0998 6.83278C8.44217 6.88493 6.74859 8.60615 6.67042 11.2923C6.64437 12.3876 6.67042 13.4568 6.67042 14.5522Z"
                        fill="#fff" />
                      <path
                        d="M20.9882 14.5357C20.9882 15.7252 21.0147 16.9148 20.9882 18.1043C20.9352 19.6903 19.9804 20.827 18.4158 20.9063C15.8698 21.012 13.2974 21.0384 10.7515 20.9327C9.05417 20.8534 8.04641 19.6903 8.01989 17.9721C7.99337 15.6988 7.99337 13.3991 8.01989 11.1258C8.04641 9.24899 9.05417 8.11234 10.9371 8.05948C13.3239 7.98017 15.7107 7.98017 18.071 8.05948C19.9009 8.13878 20.9617 9.32829 20.9882 11.1522C20.9882 12.236 20.9882 13.3727 20.9882 14.5357ZM14.4112 10.4649C12.1835 10.4914 10.3537 12.2889 10.3802 14.5093C10.4067 16.6769 12.2896 18.5272 14.4643 18.5272C16.7185 18.5272 18.6279 16.5976 18.5749 14.4036C18.5218 12.2096 16.6654 10.4385 14.4112 10.4649ZM18.7075 8.93179C18.2832 9.53976 17.8323 9.90984 17.8588 10.227C17.8854 10.5442 18.4158 11.0729 18.734 11.0465C19.0522 11.0465 19.5826 10.5178 19.6092 10.2006C19.6092 9.8834 19.1318 9.51333 18.7075 8.93179Z"
                        fill="#fff" />
                      <path
                        d="M17.9995 13.97C17.9995 15.6497 16.5596 17.0295 14.9398 16.9995C13.3799 16.9395 12 15.5298 12 13.97C12 12.3203 13.4099 10.9705 15.0897 11.0005C16.7396 11.0305 18.0295 12.3203 17.9995 13.97Z"
                        fill="#fff" />
                    </svg>
                  </a>
                </li>
                <li class="list-inline-item social-icon-2">
                  <a href=" https://www.youtube.com/channel/UCkWN8rey8MQaEr_YMVIUcyg" class="footer-icon-class"
                    target="_blank" title="Youtube"><i class="bi bi-youtube"></i></a>
                </li>
                <li class="list-inline-item social-icon-2">
                  <a href=" https://www.linkedin.com/company/miraj-entertainment-ltd/" class="footer-icon-class"
                    target="_blank" title="Linkedin"><i class="bi bi-linkedin"></i></a>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-12">
            <hr class="footer-divider" />
            <div class="copyRight-text my-3 text-center">
              © Miraj Cinemas {{ new Date().getFullYear() }} All Rights
              Reserved.
            </div>
          </div>
        </div>
      </div>
      <div class="rainbow-line">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </footer>

    <!-- MOBILE FOOTER -->

    <footer class="d-md-none" v-if="
      $route.name !== 'Seat Layout' &&
      $route.name !== 'Food and Drinks Checkout' &&
      $route.name !== 'Booking Summary' &&
      $route.name !== 'Final Ticket' &&
      $route.name !== 'Regular Booking'
    ">
      <div class="col-12">
        <div class="copyRight-text my-3 text-center">
          © Miraj Cinemas {{ new Date().getFullYear() }} All Rights
          Reserved.
        </div>
      </div>

      <div class="rainbow-line">
        <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
      </div>
    </footer>
    <div class="section-space-50 mb-1 d-md-none" v-if="$route.path == '/'"></div>
  </div>
</template>
<script>
import { FOOTER_TEXT_1, FOOTER_TEXT_2 } from "@/config";
import ExtrasService from "@/apiServices/ExtrasService";

export default {
  data() {
    return {
      address: null,
      customer_care_email: null,
      FOOTER_TEXT_1,
      FOOTER_TEXT_2,
    };
  },
  methods: {
    async getAddress() {
      try {
        const response = await ExtrasService.getAddress();
        if (response.data.status) {
          this.address = response.data.data.extra_html_content;
          // console.log("Address", this.address);
        }
      } catch (err) {
        console.log("Error in getting address ", err);
      }
    },
    async getCustomerCareEmail() {
      try {
        const response = await ExtrasService.getCustomerCareEmail();
        if (response.data.status) {
          this.customer_care_email = response.data.data.extra_html_content;
        }
      } catch (err) {
        console.log("Error in getting customer care email ", err);
      }
    },
  },
  beforeMount() {
    this.getAddress();
    this.getCustomerCareEmail();
  },
};
</script>
<style>
@import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.9.1/font/bootstrap-icons.css");

.footer a {
  color: var(--white);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.3px;
}

.footer a:hover,
.footer a.active {
  color: var(--rose-gold) !important;
}

.footer-links-list {
  padding-left: 0;
  list-style: none;
  margin-bottom: 0;
}

.footer-links-list li:not(:last-child) {
  margin-bottom: 5px;
}

.newsletter {
  overflow: hidden;
  position: relative;
  margin-bottom: 20px;
}

.newsletter .btn-transparent {
  top: 0px;
  left: 3px;
  z-index: 1;
  height: 100%;
  border-radius: 5px;
  position: absolute;
}

.newsletter input {
  padding-left: 45px;
}

.newsletter input::placeholder {
  font-size: 13px;
  font-weight: 300;
}

.footer-divider {
  width: 60%;
  margin: 0 auto;
  display: block;
  margin-top: 30px;
  margin-bottom: 20px;
  background-color: #333333;
}

.social-icon a {
  padding: 5px 5px;
  background: #ffffff;
  color: black !important;
  border-radius: 50%;
  cursor: pointer;
  font-size: 15px;
}

.social-icon a:hover {
  color: black !important;
}

.list-inline-item {
  margin: 5px !important;
}

.footer-icon-class {
  background: #ffffff;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.footer-icon-class i {
  color: #000000;
  margin-top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/footer.vue